import { Tooltip } from "antd";
import React from "react";
import { useDispatch, useSelector } from "react-redux";

import SignOffModal from "@/Components/modals/timesheet/SignOffModal";
import { ACTION_BTN_HOVER_CLR } from "@/Constants/common";
import { fetchTimesheetCount } from "@/reducers/timesheets/timesheets";
import {
  fetchTerminatedTimesheets,
  setTerminatedTimesheetsLoading,
  toggleSignOffModal,
  toggleSignOffModalData,
  updatePagination,
  updateSelectedTimesheets,
  updateToggleSelected,
} from "@/reducers/timesheets/timesheetterminated";
import { TOOLTIPTEXT, toastMessageText } from "@/utilities/CommonText";

import ActionIcons from "../../../ActionIcons";

const Actions = () => {
  const {
    pagination,
    selectedCandidate,
    terminatedTimesheets,
    selectedSignOffIds,
    selectedTimesheets,
    isSelectedAll,
    showSignOffModal,
    selectedSignOffData,
  } = useSelector((state) => state.clientTimesheetTerminated);
  const dispatch = useDispatch();
  const { clientUserAllPermissions } = useSelector((state) => state.session);

  const handleReloadTable = () => {
    dispatch(fetchTimesheetCount());
    dispatch(
      updatePagination({
        ...pagination,
        currentPage: 1,
        isLastPage: false,
      }),
    );
    dispatch(setTerminatedTimesheetsLoading(true));
    dispatch(fetchTerminatedTimesheets());
  };

  // const handleReloadTable = () => {
  //   dispatch(fetchTimesheetCount());
  //   dispatch(
  //     updatePagination({
  //       ...pagination,
  //       currentPage: 1,
  //       isLastPage: false,
  //     }),
  //   );
  //   dispatch(setTerminatedTimesheetsLoading(true));
  //   dispatch(fetchTerminatedTimesheets());
  // };
  return (
    <>
      <SignOffModal
        callbackFunc={() => {
          handleReloadTable();
        }}
        toggleSignOffModal={toggleSignOffModal}
        updateSelectedTimesheets={updateSelectedTimesheets}
        showSignOffModal={showSignOffModal}
        selectedTimesheets={selectedTimesheets}
        formData={{
          startTime: selectedSignOffData?.sign_off_start_time,
          endTime: selectedSignOffData?.sign_off_end_time,
          breakTime: selectedSignOffData?.sign_off_unpaid_break_time,
          adminTime: selectedSignOffData?.sign_off_admin_time,
          noOfVisit: selectedSignOffData?.sign_off_no_of_visit,
        }}
      />
      <div className="Actions_Wrapper tour-terminated-actions">
        <div className="flex h-[40px] cursor-pointer overflow-hidden rounded-lg bg-grey [&>*:last-child]:border-r-0 [&>*]:grid [&>*]:w-[56px] [&>*]:min-w-[56px] [&>*]:place-items-center [&>*]:border-0 [&>*]:border-r [&>*]:border-r-[#E5E6E9] [&>*]:text-txtColor">
          {(!clientUserAllPermissions ||
            clientUserAllPermissions.is_allow_to_signoff_timesheets !== 0) && (
            <Tooltip title={TOOLTIPTEXT.signOff}>
              <div
                className={`group ${ACTION_BTN_HOVER_CLR.lightBlue} ${isSelectedAll ? "cursor-not-allowed opacity-50" : ""}`}
                onClick={() => {
                  if (selectedTimesheets.length > 0) {
                    if (selectedTimesheets.length > 1) {
                      showCommonToast(toastMessageText.oneRecordToSignOff);
                    } else {
                      //     // if (!selectedObj.has_edit_required) {
                      //     //   showErrorToast("No Edit Required");
                      //     //   return false;
                      //     // }
                      // dispatch(deSelectAllCandidate());
                      dispatch(toggleSignOffModal(true));
                      dispatch(toggleSignOffModalData(selectedTimesheets[0]));
                      dispatch(updateToggleSelected(false));
                      // showAdjustAmendment({
                      //   signoff_id: selectedSignOffIds[0],
                      // });
                    }
                    // console.log(getCandidateEmails());
                  } else {
                    showCommonToast(toastMessageText.noTimesheetSelected, {
                      id: "no-timesheet-selected",
                    });
                  }
                }}
              >
                <ActionIcons type={"edit"} />
              </div>
            </Tooltip>
          )}
        </div>
      </div>
    </>
  );
};

export default Actions;
